export default __webpack_public_path__ + "static/media/blogImage2.11e14b67.jpg";